import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '../../../theme';
const defaultProps = {
    color: 'gray',
};
const Styles = labelStyles('Badge', {
    root: css `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 26px;
    padding: 3px 8px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    ${Typography.base};

    border-radius: 100px;
    ${Typography.smallPrint1Bold};

    &[data-color='gray'] {
      background-color: ${Colors.neutral700};
      color: ${Colors.neutral100};
    }

    &[data-color='white'] {
      background-color: ${Colors.neutral100};
      color: ${Colors.neutral800};
    }

    &[data-color='info'] {
      background-color: ${Colors.blue10};
      color: ${Colors.neutral800};
    }

    &[data-color='info-bold'] {
      background-color: ${Colors.blue};
      color: ${Colors.neutral100};
    }

    &[data-color='success'] {
      background-color: ${Colors.success100};
      color: ${Colors.neutral800};
    }

    &[data-color='warning'] {
      background-color: ${Colors.warning100};
      color: ${Colors.neutral800};
    }

    &[data-color='error'] {
      background-color: ${Colors.error100};
      color: ${Colors.neutral800};
    }

    &[data-color='error-bold'] {
      background-color: ${Colors.error400};
      color: ${Colors.neutral100};
    }
  `,
});
export const Badge = (_props) => {
    const props = Object.assign(Object.assign({}, defaultProps), _props);
    return (isolateComponent("span", { css: Styles.root, "data-color": props.color }, props.children));
};
//# sourceMappingURL=Badge.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
